import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-navigation-toggle-icon',
	templateUrl:'./WaPageNavigationToggleIconProPage.html',
	styles: [],
	styleUrls:['./WaPageNavigationToggleIconProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageNavigationToggleIconProPage
{
	mdContent_406 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageNavigationToggleIcon;
\`\`\``;
}
